// Central configuration for API keys
// Keys are now loaded from the .env file for security

const rawKey = import.meta.env.VITE_OPENAI_API_KEY;

// Aggressively strip quotes, whitespace, and newlines to prevent invalid header errors
export const OPENAI_API_KEY = rawKey 
  ? rawKey.toString().replace(/["']/g, '').replace(/\s+/g, '').trim() 
  : '';

export const OPENAI_API_URL = import.meta.env.VITE_OPENAI_API_URL || 'https://api.openai.com/v1/chat/completions';

if (!OPENAI_API_KEY) {
  console.warn('Missing VITE_OPENAI_API_KEY in .env file. AI features will not work.');
} else {
  // Debug log to confirm key is loaded and has correct length
  console.log(`OpenAI API Key loaded (Length: ${OPENAI_API_KEY.length}). Starts with: ${OPENAI_API_KEY.substring(0, 7)}...`);
}